module.exports = __webpack_public_path__ + "images/emoji/ghost.e1a2ba4a48d3edb4de8b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ghost.png
// module id = UT7B
// module chunks = 1